<template>
  <div class="database-list">
    <BaseContainerSpread>
      <UiPageHeader
        :title="dapLangGlobal.database"
        :description="{
          ja: lst(dapLangGlobal.databaseIntroduction, ls(dapLangGlobal.serviceName)),
          en: lst(dapLangGlobal.databaseIntroduction, ls(dapLangGlobal.serviceName)),
        }"
        icon="koicon/koicon-34"
      />
    </BaseContainerSpread>

    <BaseContainerSpread
      class="jps-list-card-layout generated-13"
      tag="section"
      v-if="ss.searched"
      :id="ss.state.storeId"
    >
      <div class="search-result-header">
        <div class="is-size-7-touch">
          <p>{{ lst({ ja:'{} データベース', en:'{} databases' }, ss.state.result?.hit) }}</p>
        </div>
        <SearchPagination :ss="ss" />
        <div class="narrow-search">
          <SearchBoxSimple :ss="ss" :auto="true" />
        </div>
        <div class="display-mode">
          <label class="is-size-7 is-hidden-mobile">
            {{ ls({ ja: "表示スタイル", en: "Display mode" }) }}
          </label>
          <UiIconRadioButton class="jps-icon-button" v-model="displayMode" value="card" id="database-result-card" icon="mdi/view-grid" arialabel="card" />
          <UiIconRadioButton class="jps-icon-button" v-model="displayMode" value="table" id="database-result-table" icon="mdi/table" arialabel="table" />
        </div>
      </div>
      <Transition name="db-item">
        <UiDatabaseResultCard v-if="displayMode === 'card'" :ss="ss" />
        <UiDatabaseResultTable v-else :ss="ss" />
      </Transition>
      <SearchPagination class="footer-paginaition" :ss="ss" :autoscroll="true" />
    </BaseContainerSpread>
  </div>
</template>

<script lang="ts" setup>
import { dapLangGlobal } from '#imports'

definePageMeta({
  qsearch: true,
  disableDefaultMargin: true,
})

const { getPageAndCache } = usePage()
const { meta } = await getPageAndCache()
useHead(meta)

const LSKEY_DISPLAY_TYPE = 'jps-db-list-display-type'
const { ls, lst } = useI18n()
const { searchDatabase } = useDatabase()

const ss: SearchStore<Database> = useSearch<Database>(
  {
    keywordFields: ['keywords'],
    keywordPlaceholder: { ja: '絞り込み', en: 'Filter' },
  },
  searchDatabase,
  {
    queryRewriter: (q: SearchQuery) => {
      q.permission = 'P'
      return q
    }
  }
)

const displayMode: Ref<'card' | 'table'> = ref('card')
watch(
  () => displayMode.value,
  (n) => lsSet(LSKEY_DISPLAY_TYPE, n),
)

const initDisplayMode = () => {
  displayMode.value = lsGet(LSKEY_DISPLAY_TYPE, 'card')
}
onMounted(initDisplayMode)
onBeforeUpdate(initDisplayMode)
await ss.restoreQuery()
</script>

<style lang="scss">
@use '@/assets/styles/scss/vue' as *;

/**ResponsiveTableにはscopeddが効かないのでそこの指定だけUnscoped */
.database-list {
  padding-top: 3rem;
  @include is-mobile() {
    padding-top: 1rem;
  }
  .jps-list-header {
    @include margin-full-width();
  }
  .result-table {
    margin-top: 1rem;
    .jps-responsive-table {
      td {
        vertical-align: middle;
      }
      .jps-srt-name {
        width: 25%;
      }
      .jps-srt-fav {
        width: 1rem;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.generated-13 {
    background-color: #fafafa;
}
</style>